import { Subject } from "rxjs";
export const LanguageSubject = new Subject(); 